import { useEffect, useState } from 'react';

import { useRolesHook } from '../../../Hooks/Maintenance/Accessibilities/rolesHooks';

import { AutoCompleteDropdownInterface } from '../../../Models/Common/FormFieldComponentInterfaces';

import QueryBuilderHelper from '../../../Utilities/Helpers/QueryBuilderHelper';

import { CachingEnum } from '../../../Utilities/Enums/CachingEnum';
import { RolesField } from '../../../Utilities/Enums/ParametersEnum';

import AutoCompleteDropdown from '../AutoCompleteDropdown';

export default function RolesDropdown(fieldProps: AutoCompleteDropdownInterface) {
	let {
		name,
		title,
		fieldValue,
		options,
		isLoadingDropdown,
		disabled,
		required,
		errorMessages,
		handleOnChange,
        hideLabel,
        fieldClassName,
        placeholder,
	} = fieldProps;

	//Use States
    const [queryStr, setQueryStr] = useState({
        pageSize: 2000,
        pageNumber: QueryBuilderHelper.DefaultPageNumValue(),
        searchString: QueryBuilderHelper.DefaultSearchValue(),
    });

	const q_queryKey = [CachingEnum.ROLES_LIST, queryStr]
    const { data, fetchStatus } = useRolesHook(q_queryKey, queryStr);
    
    const rolesProps = {
        name: name,
        title: title,
        fieldValue: fieldValue,
        options: data?.data?.list?.map((item: any) => { return { id: item?.[RolesField.PUBLIC_ID] ?? "", ...item  }}) ?? [], 
        isLoadingDropdown: fetchStatus == "fetching",
        disabled: disabled,
        required: required,
        hideLabel: hideLabel,
        errorMessages: errorMessages,
        handleOnChange: handleOnChange,
        placeholder: placeholder,
        fieldClassName,
    };

    //Rendering Functions
    return <AutoCompleteDropdown {...rolesProps} />
}
